<template>
    <div class="w-full rounded-sm bg-white">
        <div class="flex flex-col px-4 py-4">
            <div class="flex pb-4 text-sm">
                {{ $t("helpers.inputs.label.classical_view") }}
            </div>
            <SmuButton :href="url" target="_blank">
                <div class="flex gap-1 py-1 pl-1 text-xs text-wrap">
                    <SmuIcon size="lg" type="duotone" icon="shuffle" />
                    <span>
                        {{ $t("helpers.buttons.switch_to_classical_view") }}
                    </span>
                </div>
            </SmuButton>
        </div>
    </div>
</template>
<script setup lang="ts">
import { SmuButton } from "@smakecloud/smake-ui";
const { slug } = useRoute().params;
const config = useRuntimeConfig();
const url = computed(() => {
    return `https://${slug}.${config.public.productionBaseUrl}`;
});
</script>
